export default "__VITE_ASSET__3F63t_2K__"